<div class="content">
    <div class="formulario">
        <h2>Cotizador de Envios</h2>
        <form [formGroup]="quoteForm">
            <div class="row">
                <div class="col">
                    <span><b>Pais:</b></span>
                    <br>
                    <mat-form-field class="pais-campo">
                        <mat-select formControlName="pais" [(value)]="selectPais" (ngModelChange)="selectPaisChange($event)" class="pais-selected" style="background-image: url({{selectPais?.url_bandera}});">
                            <mat-option *ngFor="let pais of paises" [value]="pais">
                                <img style="width: 5vw;" [src]="pais.url_bandera" alt="">{{pais.pais}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col">
                    <span><b>Ciudad Origen:</b></span>
                    <br>
                    <mat-form-field class="ciudad-campo">
                        <mat-label>Ciudad</mat-label>
                        <mat-select formControlName="ciudadO" #ciudadO required>
                            <mat-option *ngFor="let option of CitiesO" [value]="option.ciudad" (onSelectionChange)="onSelectedOptionO(option)">
                                {{option.ciudad}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col">
                    <span><b>Ciudad Destino:</b></span>
                    <br>
                    <mat-form-field class="ciudad-campo">
                        <mat-label>Ciudad</mat-label>
                        <mat-select formControlName="ciudadD" #ciudadD required>
                            <mat-option *ngFor="let option of CitiesD" [value]="option.ciudad" (onSelectionChange)="onSelectedOptionD(option)">
                                {{option.ciudad}} ({{ option.departamento }})
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <span><b>Contraentrega:</b></span>
                    <br>
                    <mat-form-field class="cent-campo">
                        <mat-label>¿Es contraentrega?</mat-label>
                        <mat-select formControlName="contraentrega" #contraentrega required>
                            <mat-option value="SI">Si</mat-option>
                            <mat-option value="NO">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col">
                    <span><b>Valor del Producto:</b></span>
                    <br>
                    <mat-form-field class="valor-campo">
                        <mat-label>Valor</mat-label>
                        <input matInput placeholder="10000" formControlName="valor" #valor required>
                    </mat-form-field>
                </div>
            </div>
            <br>
            <span><b>Peso del Producto:</b></span>
            <br>
            <mat-form-field class="peso-campo">
                <mat-label>Peso</mat-label>
                <input matInput placeholder="1" formControlName="peso" #peso required>
            </mat-form-field>
            <span>Kilos</span>
            <br>
            <span><b>Volumen del Producto Empacado:</b></span>
            <br>
            <span style="color: red;">Si las dimensiones son incorrectas, la transportadora reliquidará el
                valor del envío y se hará el reajuste en tu saldo</span>
            <br>
            <mat-form-field class="alto-campo">
                <mat-label>Alto</mat-label>
                <input matInput placeholder="1" formControlName="valto" #valto required>
                <mat-hint>
                    Valor mayor a 1
                </mat-hint>
            </mat-form-field>
            <span>(cm) x</span>
            <mat-form-field class="ancho-campo">
                <mat-label>Ancho</mat-label>
                <input matInput placeholder="1" formControlName="vancho" #vancho required>
                <mat-hint>
                    Valor mayor a 1
                </mat-hint>
            </mat-form-field>
            <span>(cm) x</span>
            <mat-form-field class="profundo-campo">
                <mat-label>Profundo</mat-label>
                <input matInput placeholder="1" formControlName="vprofundo" #vprofundo required>
                <mat-hint>
                    Valor mayor a 1
                </mat-hint>
            </mat-form-field>
            <span>(cm)</span>
            <br>
            <button (click)="cotiza()" class="btn" [disabled]="!quoteForm.valid">Cotizar</button>
        </form>
        <div class="resultado" *ngIf="showResult">
            <div class="spinn2" *ngIf="!showData">
                <mat-spinner></mat-spinner>
                <p>¡Obteniendo valor Envio!</p>
            </div>
            <div class="value" *ngIf="showData">
                <h3>Valor Envio:</h3>
                <p><img width="80px" src="../../../assets/images/envia.png" alt=""> {{ valorFinal[0].valor_flete }}</p>
                <hr>
                <p><img width="80px" src="../../../assets/images/servientrega.png" alt="">{{ valorFinal[1].valor_flete }}
                </p>
                <hr>
                <p><img width="80px" src="../../../assets/images/interrapidisimo.png" alt="">{{ valorFinal[2].valor_flete }}</p>
            </div>
        </div>
    </div>
</div>